function MainWeb() {
}

MainWeb.fn = {
    init: function () {
        MainWeb.fn.web.call(this);
        MainWeb.fn.plusMinusQuantity.call(this);
        MainWeb.fn.generateFileImage.call(this);
        MainWeb.fn.removeFileImage.call(this);
    },

    web: function () {
        $(document).ready(function () {
            // Function to toggle form visibility
            function toggleForm(shouldShow) {
                var wrap = $('.how--many--time');
                if (shouldShow) {
                    wrap.show();
                    wrap.find('input').prop('disabled', false);
                } else {
                    wrap.hide();
                    wrap.find('input').prop('disabled', true);
                }
            }

            // Event listener for clicks on the radio buttons
            $('.hair--transplant').on('click', function () {
                toggleForm($(this).val() === 'Yes');
            });

            // Initialize form state based on the checked radio button
            toggleForm($('.hair--transplant:checked').val() === 'Yes');
        });

        $('.lightGallery-event').lightGallery({
            selector: '.lightGallery-event .image--preview',
            thumbnail: true, // Show thumbnails
            fullScreen: true, // Enable fullscreen mode
            toolbar: true, // Show the toolbar
        });
    },

    generateFileImage: function () {
        $('.customFile').each(function () {
            var _this = $(this);

            _this.on('change', function () {
                var file = this.files[0];
                var fileName = 'No file selected';
                var wrap = _this.closest('.step--file');
                var imagePreview = wrap.find('.image--preview');
                if (file) {

                    fileName = file.name;

                    var reader = new FileReader();

                    reader.onload = function (e) {
                        var imageData = e.target.result;
                        imagePreview.attr('src', imageData);
                    };

                    reader.readAsDataURL(file);
                }
                wrap.find('.file-name').addClass('black-text').text(fileName);
                MainWeb.fn.changeTextAfterChooseImage(_this);
            });
        });
    },

    plusMinusQuantity: function () {
        $(document).ready(function () {
            var quantity = $('input.quantity');
            $(document).on('click', '.minus', function () {
                if (quantity.val() <= 1) {
                    quantity.val('01');
                } else {
                    var number = Number(quantity.val()) - 1;
                    number = number < 10 ? '0' + number : number;
                    quantity.val(number);
                    MainWeb.fn.removeHairItem();
                }

            }).on('click', '.plus', function () {

                var number = Number(quantity.val()) + 1;
                number = number < 10 ? '0' + number : number;
                quantity.val(number);

                MainWeb.fn.addHairItem();
            });
        });
    },

    addHairItem: function () {
        var container = $('.steps .row');
        var newItem = container.find('.step--item:last-child').clone();

        var newItemIndex = container.find('.step--item').length;
        var number = newItemIndex + 1 + '.';

        newItem.find('.step--number').text(number);
        newItem.attr('data-step', newItemIndex + 1);
        newItem.find('input').each(function () {
            var inputName = $(this).attr('name');
            if (inputName) {
                var newName = inputName.replace(/\[\d+\]/, '[' + newItemIndex + ']');
                $(this).attr('name', newName);
            }
            $(this).val('');
        });

        if (newItemIndex >= 3) {
            newItem.addClass('mg-top-30');
        }

        container.append(newItem);
    },

    removeHairItem: function () {
        var container = $('.steps .row');
        if (container.find('.step--item').length > 1) {
            container.find('.step--item:last-child').remove();
        }
    },

    changeTextAfterChooseImage: function (el) {
        $(document).ready(function () {
            var _this = el.closest('.file--item');
            var showFile = _this.find('.show--file span');
            var remove = showFile.data('remove');
            _this.find('.show--file').append('<input class="picture-count" type="hidden" name="picture_count[]" value="1">');
            showFile.addClass('remove--image') .html('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">\n' +
                '<path d="M9.59701 6.39648L6.40234 9.59115" stroke="#F01D1D" stroke-width="1.5" stroke-linecap="square"/>\n' +
                '<path d="M9.59724 9.59302L6.3999 6.39502" stroke="#F01D1D" stroke-width="1.5" stroke-linecap="square"/>\n' +
                '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.00016 14.1668C11.4059 14.1668 14.1668 11.4059 14.1668 8.00016C14.1668 4.59441 11.4059 1.8335 8.00016 1.8335C4.59441 1.8335 1.8335 4.59441 1.8335 8.00016C1.8335 11.4059 4.59441 14.1668 8.00016 14.1668Z" stroke="#F01D1D" stroke-width="1.5" stroke-linecap="round"/>\n' +
                '</svg> '+remove+'');
        })
    },

    removeFileImage:function () {
        $(document).ready(function () {
            $('body').on('click','.remove--image', function () {
                var _this = $(this).closest('.file--item');
                var fileName =  _this.find('.file-name');
                var showFile = _this.find('.show--file');
                var fileDefault = showFile.data('file-default');
                var text = fileName.data('no-file');
                var textSample = showFile.find('span').data('sample');

                showFile.find('span').removeClass('remove--image').text(textSample);
                showFile.find('img').attr('src', fileDefault);
                showFile.find('.picture-count').remove();
                fileName.removeClass('black-text').text(text);
                _this.find('input[type=file]').val('');
            });
        })
    },

    rule: function () {
        $(document).ready(function () {
            MainWeb.fn.init.call(this);

            // Tooltip
            $(document).ready(function() {
                $('[data-toggle="tooltip"]').tooltip({
                    container: 'body'
                });
            });
        });
    },
};

MainWeb.fn.rule();
